export default __webpack_public_path__ + "static/inter-v8-latin-regular-513f22e166bab984fa607bad4cdf1899.woff";